const ITEMS = ["RNB", "House", "Afro House", "Bottomless 10PM – 12AM", "Live DJs", "Late Nights", "Every Friday", "9PM til late"];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((t) => (
      <span key={t} className="flex items-center">
        <span className="font-display px-8 text-5xl text-[#F8F6F0] sm:px-12 sm:text-7xl lg:text-8xl">{t}</span>
        <span className="text-2xl text-[var(--glow)] sm:text-3xl">✦</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative overflow-hidden border-y border-[var(--line)] py-10 sm:py-14" data-testid="editorial-marquee" aria-label="Eleganté highlights">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#09080B] sm:w-48" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#09080B] sm:w-48" />
  </section>
);
